//src/factory/symbols/createGroundingStrake.js
import * as THREE from 'three';
import { generateUniqueId } from '../../utils/generateUniqueId';

export function createGroundingStrake(
  scene,
  mousePos,
  dir = 1,
  color = 0x4500ff,
  isPreview = false,
  type = "normal",
  tempLineUUID,
  rotateValue
) {
  const group = new THREE.Group();
  const offsetGroup = new THREE.Group();
  dir = dir ?? 1;
  const width = 14;
  const height = 100;
  const rotationGizmoColor = isPreview ? 0x3333ff : 0x00ffff;
 
  const innerRadius = 2;
  const basePoint = { x: mousePos.x, y: mousePos.y };
  const groundingStrakeId = generateUniqueId('groundingStrake');
  group.userData = {
    id: groundingStrakeId,
    type: 'groundingStrake',
    isSelectable: true,
    isPreview: isPreview,
    connectedTo: null,
    basePoint,
    tempLineUUID,
    originalColor: color 
  }; 
  group.position.set(basePoint.x, basePoint.y, 0);
  group.add(offsetGroup); 
  const lineMaterial = new THREE.LineBasicMaterial({ color: color });
lineMaterial.userData = { originalColor: color };
  // Dikey çizgi
  const line1Geo = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0, 100, 0),
  ]);
  const line1 = new THREE.Line(line1Geo, lineMaterial);
  line1.userData = { originalColor: lineMaterial.color.getHex(), role: 'line1', groundingStrakeId };
  offsetGroup.add(line1);

  // Yatay çizgi
  const line2Geo = new THREE.BufferGeometry().setFromPoints([
    new THREE.Vector3(-12, 100, 0),
    new THREE.Vector3(12, 100, 0),
  ]);
  const line2 = new THREE.Line(line2Geo, lineMaterial);
  line2.userData = { originalColor: lineMaterial.color.getHex(), role: 'line2', groundingStrakeId };
  offsetGroup.add(line2);




    const line3Geo = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(-9, 105, 0),
      new THREE.Vector3(9, 105, 0),
    ]);
    const line3 = new THREE.Line(line3Geo, lineMaterial);
    line3.userData = { originalColor: lineMaterial.color.getHex(), role: 'line3', groundingStrakeId };
    offsetGroup.add(line3);

    const line4Geo = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(-6, 110, 0),
      new THREE.Vector3(6, 110, 0),
    ]);
    const line4 = new THREE.Line(line4Geo, lineMaterial);
    line4.userData = { originalColor: lineMaterial.color.getHex(), role: 'line4', groundingStrakeId };
    offsetGroup.add(line4);
    group.rotation.z = 0 * Math.PI / 180;
    

 
  
  const createFilledCircle = (radius, color) => {
    const geometry = new THREE.CircleGeometry(radius, 64);
    const material = new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide });
    return new THREE.Mesh(geometry, material);
  };

 
 
  const innerCircle = createFilledCircle(innerRadius, rotationGizmoColor);
  innerCircle.userData = {
    type: 'rotateGizmo',
    parentgroundingStrakeId: group.userData.id,
  };
 
  innerCircle.position.set(width / 2 - 7, height + 5, 0.2);



  innerCircle.visible = false
 


  offsetGroup.add(innerCircle);
//  offsetGroup.add(strechGizmo);
//  offsetGroup.add(symetrical);
 // offsetGroup.add(moveGizmo);

const textSprite = createTwoLineLabel( "Bakır" ,"Topraklama Kazığı");
textSprite.position.set(-0, 120, 1); // Yüksekliğe göre konumla
offsetGroup.add(textSprite);


  // 🔧 Offset uygulaması (merkez uca oturtulacak)
  offsetGroup.scale.set(1, dir, 1); // dir parametresi burada kullanıldı
  offsetGroup.position.set(0, 0, 0);
  offsetGroup.rotation.z  = rotateValue*Math.PI/180
    if (dir instanceof THREE.Vector3) {
      const angle = Math.atan2(dir.y, dir.x); // Radyan cinsinden açı
      group.rotation.z +=  angle ;
    }
 /*  if (scene && !isPreview) {
    scene.add(group);
  } */

  return group;
}
export function groundingBuat(scene, point, color = 0x0045ff, uuid, isPreview = false) {
    const buat = new THREE.Mesh(
        new THREE.CircleGeometry(4, 32),
        new THREE.MeshBasicMaterial({
            color,
            side: THREE.DoubleSide,
            transparent: isPreview,
            opacity: isPreview ? 0.5 : 1 // Ön izleme yarı saydam
        })
    );
    buat.position.set(point.x, point.y, 0.2);
    buat.userData = {
        type: 'buatCircle',
        socketUUID: uuid,
        isDraggable: false,
        isPreview
    };

    // 🟦 Bağlantı Klemensi yazısı
    const textSprite = createTwoLineLabel('Bağlantı\nKlemensi', '');
    textSprite.position.set(point.x + 10, point.y + 10, 0.3);
    textSprite.userData = {
        type: 'groundingBuatLabel',
        parentBuat: buat,
        offset: new THREE.Vector3(10, 30, 0),
        isPreview
    };

    if (isPreview) {
        // Ön izleme için group döndür
        const group = new THREE.Group();
        group.add(buat);
        group.add(textSprite);
        return group;
    } else {
        // Normal kullanım: sahneye ekle
        scene.add(buat);
        scene.add(textSprite);
        return buat;
    }
}

 
export function groundingBuat3(scene, point, color = 0x0045ff, uuid) {
    const buat = new THREE.Mesh(
        new THREE.CircleGeometry(4, 32),
        new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide })
    );
    buat.position.set(point.x, point.y, 0.2);
    buat.userData = {
        type: 'buatCircle',
        socketUUID: uuid,
        isDraggable: false,
    };
    scene.add(buat);

    // 🟦 Bağlantı Klemensi yazısı (Sprite olarak)
    const textSprite = createTwoLineLabel('Bağlantı\nKlemensi', '');
    textSprite.position.set(point.x + 10, point.y + 10, 0.3); // Başlangıç offset
    textSprite.userData = {
        type: 'groundingBuatLabel',
        parentBuat: buat,
        offset: new THREE.Vector3(10, 30, 0),
    };
    scene.add(textSprite);

    // ✳️ Draggable işlevi: Scene dışında yönetilmeli (aşağıda açıklanıyor)
}
export const createTwoLineLabel = (
  line1,
  line2,
  options = {}
) => {
  const {
    fontSize = 20,
    fontFamily = 'Arial',
    fontWeight = 'bold',
    color = '#ffffff',
    backgroundColor = 'transparent',
    padding = 10,
    lineHeight = 1.2,
    scaleX,
    scaleY,
    dxfFontSize = 3  // DXF export için font boyutu
  } = options;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  const textWidth = Math.max(
    ctx.measureText(line1).width,
    ctx.measureText(line2).width
  );
  const textHeight = fontSize * 2 * lineHeight;

  canvas.width = textWidth + padding * 2;
  canvas.height = textHeight + padding * 2;

  if (backgroundColor !== 'transparent') {
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  ctx.fillStyle = color;
  ctx.textBaseline = 'top';
  ctx.fillText(line1, padding, padding);
  ctx.fillText(line2, padding, padding + fontSize * lineHeight);

  const texture = new THREE.CanvasTexture(canvas);
  texture.minFilter = THREE.LinearFilter;

  const material = new THREE.SpriteMaterial({
    map: texture,
    transparent: true,
    depthTest: false, // 🛑 Bu önemli!
    depthWrite: false
  });

  const sprite = new THREE.Sprite(material);

  // 🧠 Raycaster çalışsın diye ekler:
  sprite.center.set(0.5, 0.5);
  sprite.raycast = THREE.Sprite.prototype.raycast;
  sprite.frustumCulled = false; // görünürlük optimizasyonunu kapat

  const autoScaleX = scaleX ?? fontSize * 2.5;
  const autoScaleY = scaleY ?? fontSize * 1.5;
  sprite.scale.set(autoScaleX, autoScaleY, 1);

  // DXF export için text ve fontSize bilgisini userData'ya ekle
  const fullText = line2 ? `${line1} ${line2}`.trim() : line1;
  sprite.userData = {
    ...sprite.userData,  // Mevcut userData'yı koru
    text: fullText,
    fontSize: dxfFontSize,
    layerName: '0'
  };

  return sprite;
};

export function createTextLabel(text, position, angle) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const fontSize = 48;
    const dxfFontSize = 5;  // DXF export için uygun font boyutu
    const padding = 20;

    canvas.width = 1024;
    canvas.height = 256;
    context.font = `${fontSize}px Arial`;
    context.fillStyle = '#ffffff';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, canvas.width / 2, canvas.height / 2);

    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;

    const material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, depthTest: false });
    const geometry = new THREE.PlaneGeometry(200, 50); // boyutu isteğe göre ayarla
    const label = new THREE.Mesh(geometry, material);

    // DXF export için text ve fontSize bilgisini userData'ya ekle
    label.userData = {
        type: 'groundingLabel',
        text: text,
        fontSize: dxfFontSize,
        layerName: '0'
    };

    label.position.copy(position);
    label.rotation.z = angle; // Doğru açıda döndür
    label.renderOrder = 999; // Önde olsun
    return label;
}
